import { Text, Float, OrbitControls, PresentationControls, useTexture, useGLTF } from "@react-three/drei"
import { useControls } from "leva"

export default function Experience()
{
    // // triangle position debug
    // const { trianglePositionX, trianglePositionY, trianglePositionZ } = useControls({
    //     trianglePositionX : -0.45,
    //     trianglePositionY : 1.25,
    //     trianglePositionZ : -0.86
    // })

    // // plane position/scale debug
    // const { planePositionX, planePositionY, planePositionZ } = useControls({
    //     planePositionX : -0.465,
    //     planePositionY : 0.695,
    //     planePositionZ : -0.86
    // })
    // const { planeScaleY } = useControls({
    //     planeScaleY : 0.53
    // })
    
    const { nodes } = useGLTF('./assets/blue_study_desk2.glb')
    const computerDeskTexture = useTexture('./assets/blue_study_desk5_contrast_exposure2.webp')
    computerDeskTexture.channel = 1
    computerDeskTexture.flipY = false

    const triangleTexture = useTexture('./assets/triangle.png')
    
    /**
     * Modal
     */
    const modal = document.querySelector(".modal")
    const modalExitButton = document.querySelector(".modal .modal-exit-button")
    const works = document.querySelectorAll(".works")
    const detailModal = document.querySelector(".modal2")
    const detailModalExitButton = document.querySelector(".modal2 .modal-exit-button")

    const workTitle = document.querySelector(".work-title")
    const workDescription = document.querySelector(".work-description")
    const workImage = document.querySelector(".work-image img")
    const workLink = document.querySelector(".work-image a")

    const workDetailImage1 = document.querySelector(".detail-image1 img")
    const workDetailImage2 = document.querySelector(".detail-image2 img")

    modalExitButton.addEventListener("click", hideModal)
    detailModalExitButton.addEventListener("click", hideDetailModal)

    const screenClick = () => {
        popupModal()
    }

    function popupModal() {
        modal.hidden = false
        requestAnimationFrame(() => {
            modal.classList.add("active")
        })
    }

    function hideModal() {
        modal.classList.remove("active")
    }    

    works.forEach(img => {
        img.addEventListener('click', () => {
            const workId = img.dataset.id
            openDetailModal(workId);
        })
    })

    const workImages = {
        1: {
            title: "Autumn Clay Kitchen",
            description: `I wanted to make something cozy for autumn season. 
                          I really like clay material and the dark autumn color palette matches the cozy feeling I was looking for. 
                          This is one of my favorite works in 2025.`,
            img: "./assets/works/full/work1.webp",
            detailImg1: "./assets/works/detail_images/work1_detail1.webp",
            detailImg2: "./assets/works/detail_images/work1_detail2.webp",
            link: "https://x.com/Chimakes3d/status/1976214803988480090/"
        },
        2: {
            title: "Little Sushi Place",
            description: `I love sushi, and I came up with the idea that I would make something sushi-related after I went to a sushi restaurant in Japan. 
                          I put a lot of care into the sushi materials to make it look delicious! `,
            img: "./assets/works/full/work2.webp",
            detailImg1: "./assets/works/detail_images/work2_detail1.webp",
            detailImg2: "./assets/works/detail_images/work2_detail2.webp",
            link: "https://x.com/Chimakes3d/status/1986352107675656409/"
        },
        3: {
            title: "Cozy Yard with Homemade Pizza",
            description: `An outdoorsy scene with lots of small details. 
                          I added little butterflies and a caterpillar for extra charm, 
                          and planted tomatoes to give it a home-garden vibe.`,
            img: "./assets/works/full/work3.webp",
            detailImg1: "./assets/works/detail_images/work3_detail1.webp",
            detailImg2: "./assets/works/detail_images/work3_detail2.webp",
            link: "https://x.com/Chimakes3d/status/1922930953573269848/"
        },
        4: {
            title: "Ginger Bread House",
            description: `I made this artwork for Christmas. 
                          My aim was to bring warmth and delicate touch using procedural materials. 
                          It was a great opportunity to learn geometry nodes which I used to make lots of scattered sugar on the floor.`,
            img: "./assets/works/full/work4.webp",
            detailImg1: "./assets/works/detail_images/work4_detail1.webp",
            detailImg2: "./assets/works/detail_images/work4_detail2.webp",
            link: "https://x.com/Chimakes3d/status/1870751630720700880/"
        },
        5: {
            title: "Fluffy Soufflé Pancakes",
            description: `I was learning Blender's procedural materials and wanted to make something semi-realistic that brings a cozy café atmosphere. 
                          This art helped me improve my material and lighting skills a lot. `,
            img: "./assets/works/full/work5.webp",
            detailImg1: "./assets/works/detail_images/work5_detail1.webp",
            detailImg2: "./assets/works/detail_images/work5_detail2.webp",
            link: "https://x.com/Chimakes3d/status/1839580738016194812/"
        },
        6: {
            title: "Lighthouse",
            description: `This artwork was inspired by a place I visited on a short trip during the summer. I enjoyed adding a little bit of imagination in the background! 
                          I am planning to make this scene in three.js too!`,
            img: "./assets/works/full/work6.webp",
            detailImg1: "./assets/works/detail_images/work6_detail1.webp",
            detailImg2: "./assets/works/detail_images/work6_detail2.webp",
            link: "https://x.com/Chimakes3d/status/1950110798627422319/"
        },
        7: {
            title: "Halloween Night",
            description: `Halloween theme with cute yet spooky atmosphere. 
                          This helped me a lot to learn character modeling skills. 
                          Also a great opportunity to dive into sculpting techniques to achieve complex shapes and details for characters and a gravestone.`,
            img: "./assets/works/full/work7.webp",
            detailImg1: "./assets/works/detail_images/work7_detail1.webp",
            detailImg2: "./assets/works/detail_images/work7_detail2.webp",
            link: "https://x.com/Chimakes3d/status/1851903435139948544/"
        },
        8: {
            title: "Morning Kitchen",
            description: `My goal for this project was to convey a sense of calmness by utilizing warm colors and natural lighting. 
                          My favorite part is the light ray from the window, 
                          which adds cozy morning vibes to the scene.`,
            img: "./assets/works/full/work8.webp",
            detailImg1: "./assets/works/detail_images/work8_detail1.webp",
            detailImg2: "./assets/works/detail_images/work8_detail2.webp",
            link: "https://x.com/Chimakes3d/status/1837043168891785222/"
        },
        9: {
            title: "Gerudo Town Bar",
            description: `This is an isometric version of Gerudo Town Bar from The Legend of Zelda: Breath of the Wild. 
                          When I play video games, I love exploring villages and buildings thoroughly. 
                          It's also a great learning opportunity for someone who's passionate about 3D. I love checking out 3D models in video games just for fun and to learn a little. `,
            img: "./assets/works/full/work9.webp",
            detailImg1: "./assets/works/detail_images/work9_detail1.webp",
            detailImg2: "./assets/works/detail_images/work9_detail2.webp",
            link: "https://x.com/Chimakes3d/status/1927653572352590249/"
        },
    }

    function openDetailModal(id){
        // modal popup
        detailModal.hidden = false
        modal.hidden = true
        requestAnimationFrame(() => {
            detailModal.classList.add("active")
            modal.classList.remove("active")
        })

        // detail modal contents
        const content = workImages[id];
        if(content) {
            workTitle.textContent = content.title
            workDescription.textContent = content.description
            workImage.src = content.img

            workDetailImage1.src = content.detailImg1
            workDetailImage2.src = content.detailImg2

            if(content.link) {
                workLink.href = content.link
            }
        }
    }

    function hideDetailModal() {
        detailModal.classList.remove("active")
        modal.classList.add("active")
    }
    

    return <>
        <color args={ ['#ffffff'] } attach={"background"} />
            {/* <OrbitControls makeDefault/> */}
            <PresentationControls 
                global
                polar={[0, 0]}
                azimuth={ [-0.3, 0.25] }
                damping={ 0.2 }
                snap
                cursor={ false }
            >

                {/* down triangle */}
                <Float rotationIntensity={ 0 } floatIntensity={ 1 } floatingRange={[0, 0.08]} speed={10.0}>
                    <mesh scale={[0.45, 0.4, 0.4]} position={[ -0.45, 1.2, -0.86  ]}>
                        <planeGeometry />
                        <meshBasicMaterial 
                            map={ triangleTexture }
                            transparent
                        />
                    </mesh>
                </Float>

                <mesh 
                    geometry={nodes.blueStudyDesk.geometry} 
                    position={ [-0.5, -1.3, 0] }
                >
                    <meshBasicMaterial map={ computerDeskTexture } />
                </mesh>

                {/* computer screen */}
                <mesh scale-y={0.53} position={[-0.465, 0.695, -0.86]} 
                    onClick={ screenClick }
                    onPointerEnter={ () => { document.body.style.cursor = 'pointer' } }
                    onPointerLeave={ () => { document.body.style.cursor = 'default' } }
                >
                    <planeGeometry />
                    <meshBasicMaterial color={'#636363'} />
                </mesh>

                {/* computer screen text */}
                <Text
                    color={'#eef2ff'}
                    position={[-0.465, 0.695, -0.859]}
                    font="./assets/fonts/Fredoka-Bold.ttf"
                    fontSize={ 0.14 }
                    fontWeight={700}
                    letterSpacing={0.05}
                >
                    Click Me!
                </Text>

                <mesh
                    geometry={ nodes.lightbulb.geometry }
                    position={ [nodes.lightbulb.position.x - 0.5, nodes.lightbulb.position.y - 1.3, nodes.lightbulb.position.z] }
                    rotation={ nodes.lightbulb.rotation }
                >   
                </mesh>
            </PresentationControls>
    </>
}